<template>
  <div class="hp-base-panel-wrp">
    <div class="cert-panel hp-base-panel">
      <div class="hp-title">
        <em class="left">倾听风格</em>
      </div>
      <div class="tabs-wrap">
        <template v-for="tag in tags">
          <span class="expert-label" :key="tag">{{ tag }}</span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tags: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
.hp-title {
  padding-bottom: 26px !important;
  padding-top: 50px;
  &:nth-of-type(1) {
    padding-top: 0;
  }
}
.cert-panel {
  .normal-text {
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #6c798c;
    line-height: 38px;
  }
  .expert-list {
    .expert-item {
      width: 100%;
      // height: 180px;
      // background: #ffffff;
      // box-shadow: 0px 0px 40px 0px #ebefff;
      // border-radius: 10px;
      background: #f8f9ff;
      border-radius: 16px;
      margin-bottom: 20px;
      padding: 20px 22px;
      box-sizing: border-box;
      overflow: hidden; // 清除浮动
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .tabs-wrap {
    clear: both; // 清除浮动
    padding: 0;
    box-shadow: none;
    .expert-label {
      display: inline-block;
      margin: 0 15px 15px 0;
      padding: 0 30px;
      height: 52px;
      background: #f8f9ff;
      border-radius: 26px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #434c5c;
      line-height: 52px;
    }
    .expert-tags {
      font-size: 26px;
      color: #6c798c;
      line-height: 39px;
    }
  }
}
</style>
